// @flow

import * as React from 'react';

export default function ExpandTriangle(props) {
    return (<svg {...props} width="13px" height="13px" viewBox="0 0 17 17" version="1.1">
        <polygon id="Triangle" fill="#000000" points="16.8769531 8.5 0.123046875 16.8769531 0.123046875 0.123046875" />
    </svg>);
}




// WEBPACK FOOTER //
// ./src/Reengagement/ExpandTriangleIcon.jsx